/* joacă bună — filtre colecție: plafonează prețul la intervalul disponibil. */
(() => {
  const init = () => {
    document.querySelectorAll('.colectie__bara').forEach((form) => {
      const fields = Array.from(form.querySelectorAll('[data-price-clamp]'));
      if (!fields.length) return;

      const clamp = (field) => {
        if (field.value === '') return;
        const value = Number(String(field.value).replace(',', '.'));
        const maximum = Number(field.dataset.priceMax);
        if (!Number.isFinite(value) || !Number.isFinite(maximum)) return;
        const bounded = Math.min(Math.max(value, 0), maximum);
        field.value = bounded.toFixed(2).replace(/\.00$/, '');
      };

      fields.forEach((field) => field.addEventListener('change', () => clamp(field)));
      form.addEventListener('submit', () => fields.forEach(clamp));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
